import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import caseIcon from "../assets/icons/case.svg";
import { Trans } from "react-i18next";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import step2 from "../assets/image/acrobatRead/step2.png";
import step4 from "../assets/image/acrobatRead/step4.png";
import step5 from "../assets/image/acrobatRead/step5.png";
import step7 from "../assets/image/acrobatRead/step7.png";
import step9 from "../assets/image/acrobatRead/step9.png";
import step10 from "../assets/image/acrobatRead/step10.png";
import step11 from "../assets/image/acrobatRead/step11.png";
import step12 from "../assets/image/acrobatRead/step12.png";
import step13a from "../assets/image/acrobatRead/step13a.png";
import step13b from "../assets/image/acrobatRead/step13b.png";
import step13c from "../assets/image/acrobatRead/step13c.png";


const AcrobatReader = () => {
    const { t, i18n } = useTranslation();
    const lastUpdated = "2026-03-19";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        return [
            t("sidebar.cases.acrobatReader"),
            "",

            t("acrobatReader.step1"),
            t("acrobatReader.step2"),
            t("acrobatReader.step3"),
            t("acrobatReader.step4"),
            t("acrobatReader.step5"),
            t("acrobatReader.step6"),
            "",

            t("acrobatReader.step7"),
            t("acrobatReader.step8"),
            t("acrobatReader.step9"),
            "",

            t("acrobatReader.step10"),
            "",

            t("acrobatReader.step11"),
            `- ${t("acrobatReader.step11a")}`,
            `- ${t("acrobatReader.step11b")}`,
            `- ${t("acrobatReader.step11c")}`,
            `- ${t("acrobatReader.step11d")}`,
            `- ${t("acrobatReader.step11e")}`,
            `- ${t("acrobatReader.step11f")}`,
            "",

            t("acrobatReader.step12"),
            `- ${t("acrobatReader.step12a")}`,
            "",

            t("acrobatReader.step13"),
        ].join("\n");
    };
    
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          py-3
          max-w-3xl
        "
            >
                <div className="relative flex items-center justify-between gap-3">
                    <div className="flex items-center gap-1">
                        <div>
                            <img src={caseIcon} alt="case" className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-[16px] tabletpro:text-[12px] mini_mobile:text-[14px] text-[#0087FE] font-normal">
                                {t("sidebar.cases.title").toUpperCase()}
                            </p>
                        </div>
                    </div>

                    <CopyButton text={buildCopyText(t)} />
                </div>

                <div className="mt-2 relative">
                    <section className='flex gap-4'>
                        <p className='text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[22px] mini_mobile:text-[24px] mobile:text-[34px] font-semibold'>{t("sidebar.cases.acrobatReader")}</p>
                    </section>

                    <section className='flex flex-col gap-4 mt-1'>
                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="acrobatReader.step1"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="acrobatReader.step2"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step2

                        }}>
                            <img
                                src={step2}
                                alt="step2"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="acrobatReader.step3"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="acrobatReader.step4"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step4

                        }}>
                            <img
                                src={step4}
                                alt="step4"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="acrobatReader.step5"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step5

                        }}>
                            <img
                                src={step5}
                                alt="step5"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="acrobatReader.step6"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="acrobatReader.step7"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step7

                        }}>
                            <img
                                src={step7}
                                alt="step7"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="acrobatReader.step8"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="acrobatReader.step9"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step9

                        }}>
                            <img
                                src={step9}
                                alt="step9"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="acrobatReader.step10"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step10

                        }}>
                            <img
                                src={step10}
                                alt="step10"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="acrobatReader.step11"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="acrobatReader.step11a"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="acrobatReader.step11b"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="acrobatReader.step11c"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="list-none text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="acrobatReader.step11d"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="acrobatReader.step11e"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="acrobatReader.step11f"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                        </ul>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step11

                        }}>
                            <img
                                src={step11}
                                alt="step11"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="acrobatReader.step12"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="acrobatReader.step12a"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                        </ul>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step12

                        }}>
                            <img
                                src={step12}
                                alt="step12"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="acrobatReader.step13"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step13a

                        }}>
                            <img
                                src={step13a}
                                alt="step13a"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step13b

                        }}>
                            <img
                                src={step13b}
                                alt="step13b"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step13c

                        }}>
                            <img
                                src={step13c}
                                alt="step13c"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                    </section>

                    <section className='flex gap-4 mt-4 flex-col desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.cases.foxit")}
                            to="/cases/foxit"
                        />
                        <NextSectionCard
                            label={t("sidebar.pricing")}
                            to="/pricing"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default AcrobatReader
